// removed by extract-text-webpack-plugin
module.exports = {"root":"_3Vk6J","bg":"_1IAeE","border_box":"wNQi5","left":"o92e1","right":"_2MAIf","wrapper":"_2hE0R","warning":"_2beRS","title":"_2nIGN","text":"_3Ls7k","content_form":"_1c8a1","logo":"BBzbG","logoLower":"_3VBV9","textChange":"_3tIM3","textChange2":"_3P2gP","name":"_2AlOK","input":"HfRjv","input_error":"_2cXYE HfRjv","register_link":"xRFBy","submit_btn":"_3UJ09","chat_btn":"_2y98W","box":"_10GqN","category":"_1oDJ7","box_btn":"_22DBz","tabs":"_3J0U0"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/login/Login.css
// module id = 590
// module chunks = 0